module.exports = __webpack_public_path__ + "static/media/rn.b77ce302.mp3";